var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-evenly align-center"},[_c('v-autocomplete',{attrs:{"items":_vm.brokers,"item-text":"hostname","item-value":(item) =>
        _vm.includeHostname
          ? `${item.mqttBrokerId}:${item.hostname}`
          : item.mqttBrokerId,"prepend-inner-icon":"mdi-access-point","label":_vm.$t('mqtt.selectBroker')},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}}),_c('create-broker-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }